import { RootState } from '../store';

export const selectedAll = (state: RootState, tableKey: string, count: number) =>
    state.tables[tableKey].selection.length === count;

export const selectedSome = (state: RootState, tableKey: string) =>
    state.tables[tableKey].selection.length > 0;

export const selectedOne = (state: RootState, tableKey: string) =>
    state.tables[tableKey].selection.length === 1;

export const singleSelected = (state: RootState, tableKey: string) =>
    state.tables[tableKey].selection.length === 1 ? state.tables[tableKey].selection[0] : undefined;

export const selected = (state: RootState, tableKey: string) =>
    state.tables[tableKey].selection;

export const isSelected = (state: RootState, tableKey: string, id: string) =>
    state.tables[tableKey].selection.find((x) => x === id) !== undefined;

export const getStart = (state: RootState, tableKey: string) => {
    const paging = state.tables[tableKey].paging;
    return paging.currentPage * paging.itemsPerPage;
};

export const getLimit = (state: RootState, tableKey: string) => {
    const paging = state.tables[tableKey].paging;
    return paging.itemsPerPage;
};

export const getSorting = (state: RootState, tableKey: string) =>
    state.tables[tableKey].sorting;

export const getFilter = (state: RootState, tableKey: string, filterKey: string) =>
    state.tables[tableKey].filters[filterKey];

export const getFilters = (state: RootState, tableKey: string) =>
    state.tables[tableKey].filters;

export const getPaging = (state: RootState, tableKey: string) =>
    state.tables[tableKey].paging;

export const getSearch = (state: RootState, tableKey: string) =>
    state.tables[tableKey].search;